import { Navigate, useRoutes } from "react-router-dom";
import SimpleLayout from "./layouts/simple";
import PosPage from "./pages/PosPage";
import Menu from "./pages/Selling/Menu";
import Tables from "./pages/Tables";
import Widgets from "./pages/Widgets";
import Items from "./pages/Items";
import { useContext } from "react";
import { AppContext } from "./AppContext";
import OrderTabs from "./pages/Tables/OrderTabs";
import ProductionCenter from "./pages/ProductionCenter/ProductionCenter";
import KitchenDashboard from "./pages/KitchenDashboard";

// ----------------------------------------------------------------------

export default function Router() {
    const {
        isTabsPos,
        isKitchenUser,
        restaurantSettings,
        restaurantSettingsStatus,
    } = useContext(AppContext);
    const kdsRoleProfile =
        restaurantSettings?.docs?.[0]?.kds_production_center?.trim?.();
    const kitchenRedirectTarget = kdsRoleProfile
        ? `/kds/${encodeURIComponent(kdsRoleProfile)}`
        : "/kds";
    const kitchenRoutes =
        restaurantSettingsStatus === "loading"
            ? [
                  {
                      path: "*",
                      element: null,
                  },
              ]
            : [
                  {
                      path: "/kds",
                      element: <KitchenDashboard />,
                  },
                  {
                      path: "/kds/:productionCenter",
                      element: <KitchenDashboard />,
                  },
                  {
                      path: "*",
                      element: <Navigate to={kitchenRedirectTarget} replace />,
                  },
              ];

    const routes = useRoutes(
        isKitchenUser
            ? kitchenRoutes
            : [
        {
            path: "/tables",
            element: isTabsPos ? <OrderTabs /> : <Tables />,
        },
        {
            path: "/pos/:tableName/:orderName?",
            element: <PosPage />,
        },
        {
            path: "/items",
            element: <Items />,
        },
        {
            path: "/production-center",
            element: <ProductionCenter />,
        },
        {
            path: "/kds",
            element: <KitchenDashboard />,
        },
        {
            path: "/kds/:productionCenter",
            element: <KitchenDashboard />,
        },
        {
            path: "/dashboard",
            children: [
                { element: <Navigate to="/dashboard/selling" />, index: true },
                { path: "menu", element: <Menu /> },
                { path: "widgets", element: <Widgets /> },
            ],
        },
        {
            element: <SimpleLayout />,
            children: [
                { element: <Navigate to="/tables" />, index: true },
                { path: "404", element: <Tables /> },
            ],
        },
              ]
    );

    return routes;
}
